<template>

  <div v-if="previous_attempts && previous_attempts.length > 0" class="exam-progress">

    <h2>Your previous attempts</h2>

    <p>{{ exam_details.previous_attempts_message }}</p>

    <table class="table table-hover table-responsive">
        <tbody v-for="(attempt,index) in previous_attempts" :key="index">
            <tr>
              <td v-text="attempt.start_datetime.split(' ')[0] + ' '"></td>
              <td v-text="attempt.start_datetime.split(' ')[1] + ' '"></td>
              <td v-text="attempt.score + '%'"></td>
              <td>
                  <a
                    class="user-attempt-wrapper"
                    @click.prevent="showResults(attempt.exam_instance_id, attempt.can_review)"
                  >
                    <span v-text="attempt.can_review ? ' Review »' : ''"></span>
                  </a>
              </td>
            </tr>
        </tbody>
    </table>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardPreviousAttempts",
  computed: {
    ...mapState("exam", ["exam_details", "previous_attempts"])
  },
  methods: {
    showResults(exam_instance_id, can_review) {
      if (can_review) {
        this.$store.dispatch("showOverallResults", {exam_instance_id});
      }
    }
  }
};
</script>
